import template from "./change-password-modal.html";

//change-password-modal
export function controller(api, loadingService, toastr) {
	const ctrl = this;

	ctrl.$onInit = onInit;
	ctrl.changePassword = changePassword;
	ctrl.handleClose = handleClose;

	function onInit() {
	}

	function handleClose() {
		ctrl.modalInstance.close();
	}
	
	function changePassword() {
		const params = {
			CurrentPassword: ctrl.currentPassword,
			Password: ctrl.newPassword
		};
		
		const promise = api
			.post("api/account/password/change", params)
			.then(() => {
				toastr.success("Your password has been updated.");
				ctrl.modalInstance.close();
			});

		loadingService.watch(promise);
	}
}

export default angular
	.module("vesl.components.change-password-modal", [])
	.component("changePasswordModal", {
		controller,
		template,
		bindings: {
			close: "&",
			modalInstance: "<"
		}
	}).name;
